import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { Tokens } from '@atlassian/jira-custom-theme-constants';

const SIDEBAR_PADDING_HORIZONTAL_LEFT = gridSize * 3;
const SIDEBAR_PADDING_HORIZONTAL_RIGHT = gridSize;

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ThemedContainer = styled.div<{
	shouldAddPadding?: boolean;
	isSidebarOpen?: boolean;
	withSidebar?: boolean;
	withDynamicHeight?: boolean;
	withOverflow?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: ({ withSidebar }) => (withSidebar ? undefined : Tokens.COLOR_TEXT),
	boxSizing: 'border-box',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ withDynamicHeight }) => (withDynamicHeight ? 'auto' : '100%'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	minHeight: ({ withDynamicHeight }) => (withDynamicHeight ? '100%' : 'auto'),
	display: 'flex',
	flexFlow: 'column nowrap',
	justifyContent: 'flex-start',
	paddingTop: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	paddingRight: ({ shouldAddPadding, isSidebarOpen }) =>
		!shouldAddPadding || isSidebarOpen ? 0 : token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	paddingBottom: ({ shouldAddPadding, isSidebarOpen }) =>
		!shouldAddPadding || isSidebarOpen ? 0 : token('space.300', '24px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	paddingLeft: ({ shouldAddPadding }) => (shouldAddPadding ? token('space.300', '24px') : 0),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	overflow: ({ withOverflow }) => (withOverflow ? 'auto' : 'visible'),
});

type ContentWrapperProps = {
	isSidebarOpen?: boolean;
	sidebarWidth: number;
};

/**
 * @deprecated use primitives instead. Remove when cleaning up 'jsw.list.sidebar-layout-update'
 */
// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ContentWrapper = styled.div<ContentWrapperProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	color: Tokens.COLOR_TEXT,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: ({ isSidebarOpen, sidebarWidth }) =>
		isSidebarOpen
			? `calc(100% - ${
					sidebarWidth + SIDEBAR_PADDING_HORIZONTAL_LEFT + SIDEBAR_PADDING_HORIZONTAL_RIGHT
				}px)`
			: '100%',
	display: 'flex',
	flexDirection: 'column',
	paddingTop: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	paddingRight: ({ isSidebarOpen }) => (isSidebarOpen ? `${SIDEBAR_PADDING_HORIZONTAL_LEFT}px` : 0),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	paddingBottom: ({ isSidebarOpen }) => (isSidebarOpen ? token('space.300', '24px') : 0),
	paddingLeft: 0,
});
